<template>
    <div class="overlay">
        <div class="overlay_inner service_info">
            <p class="note" v-translate>Informace o přiřazené službě</p>
            <ul>
                <li><translate>Přiřazeno:</translate><span v-html="$_date_formatFull(service.date_assigned)"></span></li>
                <li><translate>Přiřadil:</translate><span>{{ service.user_assigned }}</span></li>
                <li><translate>Upraveno:</translate><span v-html="$_date_formatFull(service.date_updated)"></span></li>
                <li><translate>Upravil:</translate><span>{{ service.user_updated }}</span></li>
            </ul>
            <a
                    class="btn btn_action btn_close"
                                        :title="'Zavřít' | translate"
                    @click.stop.prevent="emitClose"
                    v-translate>Zavřít
            </a>
        </div>
    </div>
</template>

<script>
	export default {
		name: "ServiceInfoPopup",
        props: {
	        service: Object
        },
        methods: {
			emitClose() {
				this.$emit('close')
            }
        }
	}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/servicesList/ServiceInfoPopup.vue